export default __webpack_public_path__ + "static/media/no-image.ef44ebf6.svg";